import React from 'react';
import moize from 'moize';

const Drop = ({ color }) => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 15">
    <path style={{ fill: "var(--grey-2)" }} fillRule="evenodd" d="M558,324 C558,323.382 558.187,322.807 558.508,322.33 C558.506,322.387 558.5,322.443 558.5,322.5 C558.5,324.71 560.29,326.5 562.5,326.5 C562.557,326.5 562.613,326.494 562.67,326.491 C562.193,326.812 561.618,327.001 561,327.001 C559.343,327.001 558,325.657 558,324 M561,315.5 C561,315.5 557,320.239 557,322.999 C557,325.761 558.79,328 561,328 C563.209,328 565,325.761 565,322.999 C565,320.239 561,315.5 561,315.5 M561,329 C558.238,329 556,326.313 556,322.999 C556,319.686 561,314 561,314 C561,314 566,319.686 566,322.999 C566,326.313 563.761,329 561,329" transform="translate(-556 -314)"/>
  </svg>
);

export default moize.react(Drop, { maxSize: 3 });



// WEBPACK FOOTER //
// ./src/components/Icon/drop.js